import { Pipe, PipeTransform } from '@angular/core';
import { IsNotNull } from '@apply4u/shared/helpers/common/type-safe-helpers';

@Pipe({
  name: 'SplitSkillsPipe',
  standalone: true
})
export class SplitSkillsPipe implements PipeTransform {

  transform(text: string, by: string) {
    if (IsNotNull(text)) {
      return text.split("|").map(d => d.trim()).filter(d => d != null && d != '');
    }
    else {
      return [];
    }
  }
}